export enum SectionType {
  CALL_OVERVIEW = "call-overview",
  INSTANT_CONNECT_INSIGHT = "instant-connect-insight",
  TRENDS = "trends",
  DIRECT_CALL = "direct-call"
}
